<template>
    <div>
        <!-- 我的收藏 -->
        <div class="expert">
            <Breadcrumb></Breadcrumb>
            <collect></collect>          
        </div>
        <footers v-if="footersType == 0"></footers>
    </div>
</template>

<script>
    import Breadcrumb from '@/views/Breadcrumb.vue';
    import footers from '@/views/footers.vue';
    import collect from '@/components/collect.vue';
    export default {
        components: {
            Breadcrumb,
            footers,
            collect
        },
        data() {
            return {
				footersType : 0,

            }
        },
        created() {

        },
        mounted() {
			this.footersType = this.$route.query.footersType || 0;
            // this.handleData()
        },
        methods: {
            handleData() {
                // let returnData = [{
                //         flowOrder: 1,
                //     },
                //     {
                //         flowOrder: 2,
                //     },
                //     {
                //         flowOrder: 3,
                //     },
                // ]
                // returnData.forEach((item) => {
                //     item.checked = false
                // })
                // this.expertList = returnData;
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            collet(val) {
                if (val === 1) {
                    this.isShow1 = !this.isShow1;
                }
            },
            select1(e) {
                if (e === 1) {
                    this.isShow = !this.isShow;
                    // this.isShow1 = false;
                }
            },
            collect(index) {
                this.expertList[index].checked = !this.expertList[index].checked
                // 每次点击判断是否全部选中，将状态赋值给
                let isSelectedAll = this.expertList.every((item) => item.checked);
                // console.log(isSelectedAll, 'isSelectedAll')
                this.showAllSelected = isSelectedAll;
                let data = this.expertList.filter((item) => item.checked)
                console.log(data, 'data')

            },
            // 提交
            // submit() {
            //   let data = this.itemData.filter((item) => item.checked)
            //   console.log('data: ', data)
            // },
            checkAll() {
                this.showAllSelected = !this.showAllSelected
                this.oneCheck = {}
                this.expertList.forEach((item) => {
                    item.checked = this.showAllSelected
                })
                console.log(this.oneCheck, "==danxa")
                console.log(this.expertList, '全选---')
                // this.checked = false
                // 每次点击判断是否全部选中，将状态赋值给
                // let isSelectedAll = this.expertList.every((item) => item.checked)
                // this.isBlanced = isSelectedAll
                // this.isShow1 = !this.isShow1;
            }


        }
    }
</script>

<style scoped>
    .expert {
        padding: 0 19%;
        /* margin-bottom: 100px; */
    }

    .boxshow {
        box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .pad-16 {
        padding: 16px;
    }

    .flex-1 {
        display: flex;
        align-items: center;
        /* justify-content: space-between; */
    }

    .experts {

        margin-top: 16px;

    }

    .experts p {
        font-size: 20px;
        color: #222222;
        margin-left: 10px;
    }

    .left-icon {
        width: 6px;
        height: 20px;
        background: #3377FF;
        border-radius: 18px;
    }

    .all-check {
        background: #FAFAFA;
        border-radius: 4px 4px 4px 4px;
    }

    .check {
        /* width: 100%; */
        /* height: 352px; */

        color: #222222;
    }

    .check-1 {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
    }

    .check-1 p {
        padding: 4px 12px;
        font-size: 14px;
    }

    .check-1-p {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .check-1-p p:first-child {
        color: #3377FF;
        background: #F0F5FF;
        border-radius: 8px 8px 8px 8px;
    }

    .check-p {
        margin-right: 24px;
        min-width: 74px;
        padding: 0 !important;
    }

    .jus-bet {
        justify-content: space-between;
    }

    .align-1 {
        align-items: center;
    }

    .shouqi {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #666666;
    }

    .shouqi span {
        padding-right: 8px;
    }

    .col-22 {
        color: #222222;

    }

    .hed-img {
        width: 160px;
        height: 160px;
        padding-right: 16px;
    }

    .sex-img {
        width: 14px;
        height: 14px;
    }

    .online {
        font-size: 14px;
        color: #3377FF;
        padding: 8px 16px;
        background: #F0F5FF;
        white-space: nowrap;
        border-radius: 35px 35px 35px 35px;
    }

    .mb-8 {
        margin-bottom: 8px;
    }

    .name-1 {
        font-size: 20px;
        padding-right: 9px;
    }

    .name-2 {
        color: #999999;
        font-size: 14px;
        white-space: nowrap;
        padding-right: 8px;
    }

    .name-3 {
        font-size: 14px;
        font-weight: normal;
    }

    /deep/.el-pagination {
        text-align: center;
    }

    .footers {
        margin-top: 25px !important;
    }

    .colet {
        color: #3377FF !important;
    }

    .colet-1 {

        color: #222222;
    }

    .clool {
        border: 1px solid #3377FF;
        border-radius: 4px;
        padding: 18px;
    }

    .clool-1 {
        border: 1px solid #EFEFEF;
        border-radius: 4px;
        padding: 18px;
    }

    .clool-2 {
        border: 0;
        border-radius: 0;
        padding: 0;
    }

    .cursor {
        cursor: pointer;
    }

    .checkall {
        border-top: 1px solid #EFEFEF;
        padding: 16px 0 0 16px;
        margin-top: 26px;
    }

    .uncollect {
        font-size: 14px;
        color: #FFFFFF;
        padding: 8px 16px;
        background: #3377FF;
        border-radius: 35px 35px 35px 35px;
    }

    .quanxuan p {
        color: #222222;
        font-size: 14px;
    }
</style>
